<template>
  <div id="app">
    <ContentLeft />
    <ContentRight />
  </div>
</template>

<script>
import ContentLeft from '@/components/ContentLeft';
import ContentRight from '@/components/ContentRight';

export default {
  name: 'App',
  components: {
    ContentLeft,
    ContentRight
  }
}
</script>

<style>
/* css reset */
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; } 
body, button, input, select, textarea { font:12px/1.5tahoma, arial, \5b8b\4f53; } 
h1, h2, h3, h4, h5, h6{ font-size:100%; } 
address, cite, dfn, em, var { font-style:normal; } 
code, kbd, pre, samp { font-family:couriernew, courier, monospace; } 
small{ font-size:12px; } 
ul, ol { list-style:none; } 
a { text-decoration:none; } 
a:hover { text-decoration:underline; } 
sup { vertical-align:text-top; } 
sub{ vertical-align:text-bottom; } 
legend { color:#000; } 
fieldset, img { border:0; } 
button, input, select, textarea { font-size:100%; } 
table { border-collapse:collapse; border-spacing:0; }

html, body {
  background: #eee;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 1024px;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 0 15px #c0c0c0;
  background: #fff;
  position: relative;
  margin: 0 auto;
  margin-top: 60px;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (max-width: 1024px) {
  #app {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }
}

.iconfont {
  color: #00b38a;
  font-size: 14px;
}

@media print {
  @page {
    margin: 0;
    padding: 0;
  }
  #app {
    margin: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue